import { Bike } from "models"
import { CheckOutStateType } from "store/type"

export enum StatusEnum {
	"ALL" = 0,
	"IN_SERVICE" = 1,
	"STOLEN" = 2,
	"DESTRUCT" = 3,
	"SOLD" = 5,
}

export type bikeFleetStatusListProps = StatusEnum.ALL | StatusEnum.IN_SERVICE | StatusEnum.DESTRUCT

export type BikeFleetType = {
	choice: boolean
	fnuciCode: string
	operator: string
	brand: string
	model: string
	type: string
	color: string
	status: `${StatusEnum}`
	proofOfRegistration: string
	activation: string
	isSelectable?: boolean
}

export type BikeStatusProps = false | `${StatusEnum}`

export type BikeFleetStateProps = {
	currentBikeFleetStatusSelected: BikeStatusProps
	selectBikeFleetAll: BikeStatusProps
	bikeFleet: Array<Partial<Bike>>
	filteredBikeFleet: Array<BikeFleetType>
	searchBikeFLeet: string
	checkOutState: {
		updateBike: CheckOutStateType
		bikeFleet: CheckOutStateType
	}
	error: {
		updateBike: boolean | string
		bikeFleet: boolean | string
	}
	updateBike: {
		error: Array<string>
		success: Array<string>
	}
}

export type UploadBikefleetResponse = {
	bike_id: string
	bike_status: number
	row_version: string
}

export type Column = {
	accessor: string
}

export type ColumnSizes = {
	[key: string]: string
}
